import { makeStyles } from "@mui/styles";
import Autocomplete from "@mui/material/Autocomplete";
import { spacing } from "@mui/system";
import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import styled from "styled-components";
import { setSnackbar } from "../../snackbar/api/snackbar";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import {
  post, put,
  get as getAccountDisconnects,
} from "../api/actions";
import StatusTag from "../../apl/components/StatusTag";
import SearchIcon from '@mui/icons-material/Search';
import { formatMoney } from "../../../setup/helpers";
import {
  Checkbox, Grid,
  ButtonGroup, IconButton, Link, Breadcrumbs as MuiBreadcrumbs, Divider as MuiDivider, Paper as MuiPaper, Table, TableBody, TableContainer, TableCell,
  TableHead, TablePagination, TableRow, TableSortLabel, Toolbar, Tooltip, Typography, FormControlLabel, Switch, Menu, MenuItem, TextField as MuiTextField, Button as MuiButton,
  FormControl, InputLabel, Select, Input,
  Card as MuiCard,
  CardContent, Paper,
  CircularProgress as MuiCircularProgress,
} from "@mui/material";

import {
  EditableTable, newDropDownField,
  newConditionalOnSelectButton
} from "../../../components/EditableTable";
import { txtBoxDateFormatter } from "../../../setup/helpers";
import { searchAccountsByFieldAndValue, updateFilters, searchForAccountsByFilters } from '../../accountsSearch/api/actions';
import { getAllPropertyPreviews } from '../../apl/api/actions';
const TextField = styled(MuiTextField)(spacing);
const Button = styled(MuiButton)(spacing);
const Card = styled(MuiCard)(spacing);
const CircularProgress = styled(MuiCircularProgress)(spacing);
/*

*/
const AccountDisconnectForm = (props) => {
  const useStyles = makeStyles((theme) => ({
    container: {
      display: "flex",
      flexWrap: "wrap",
    },
    loadingIcon: {
      position: "absolute",
      left: "50%",
      top: "50%",
      transform: "translate(-50%, -50%)",
    },
  }));

  const dispatch = useDispatch();
  const [submitted, setSubmitted] = React.useState(false);
  // Filters
  const [customerType, setCustomerType] = React.useState(null);
  const [accountStatusType, setAccountStatusType] = React.useState("Active");
  const [searchQuery, setSearchQuery] = React.useState(""); // should be all thats needed to reduce the disconnects shown to only that accounts
  const [property, setProperty] = React.useState(null);
  const [propertyName, setPropertyName] = React.useState(null);
  const [accountBalanceOwedFilter, setAccountBalanceOwedFilter] = React.useState(false);

  // Table Data management
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [resetCache, setResetCachedData] = React.useState(true);
  const [focus, setFocus] = React.useState(false);
  const [minAccountObj, setMinAccountObj] = React.useState(true);
  const [SearchOnTypeInput, setSearchOnTypeInput] = React.useState(false);
  const [selectedAccount, setSelectedAccount] = React.useState(null);
  const [accountVerrified, setAccountVerrified] = React.useState(false);
  const [selctedDisconnectType, setSelctedDisconnectType] = React.useState("14");
  const [disconnectAmount, setDisconnectAmount] = React.useState(0);

  const classes = useStyles();

  const handleChangeRowsPerPage = (rowsPerPage) => {
    setPage(0);
    setResetCachedData(false);
    setRowsPerPage(rowsPerPage);
  };

  const handleChangePage = (page) => {
    setResetCachedData(false);
    setPage(page);
  };

  const onAccountStatusTypeSelected = (selection) => {
    setAccountStatusType(selection);
    setResetCachedData(true);
    setPage(0);
  }

  const onCustomerTypeSelected = (selection) => {
    setCustomerType(selection);
    setResetCachedData(true);
    setPage(0);
  }

  const handleSelectedPropertyChange = (event) => {
    setPage(0);
    setResetCachedData(true);
    if (event.target.value == "" || event.target.value == null) {
      setPropertyName(null);
    }
    else {
      var target = props.apl.data.propertyPreviews.find(x => x.uuid === event.target.value);
      setPropertyName(target.name);
    }
    setProperty(event.target.value);
  };


  // When the textbox changes
  const handleSearchTargetChange = (event) => {
    setSearchQuery(event.target.value);
    console.log(event.target.value);
    if (SearchOnTypeInput) {
      setPage(0);
      setResetCachedData(true);
      getAccountsWithQuery();
    }
  }



  const getAccountsWithQuery = () => {
    const propertyUuid = property;
    const query = { page, rowsPerPage, customerType, searchQuery, propertyUuid, accountStatusType, resetCache, accountBalanceOwedFilter, minAccountObj, serviceAddress: true };
    props.searchForAccountsByFilters(query);
  };

  const handleSearchTargetButtonClicked = () => {
    setPage(0);
    setResetCachedData(true);
    getAccountsWithQuery();
  }


  useEffect(() => {
    if (props.accountsSearch.data.accountPreviews.items) {
      if (!props.isAccountPage) {
        if (((page + 1) * rowsPerPage > props.accountsSearch.data.accountPreviews.items.length) || resetCache) {
          getAccountsWithQuery();
        }
      }
      else {
        // If initial account hasnt come in yet on the account management page
        if (selectedAccount == null && !props.account.isLoading) {
          let selectedAcct = props.account.data.account;
          let unit = props.account.data.unit;
          let property = props.account.data.property;
          let pastDue = props.account.data.ongoingAccountBalance?.pastDue || 0;
          setDisconnectAmount(pastDue);
          setSelectedAccount({
            id: selectedAcct.id,
            uuid: selectedAcct.uuid,
            propertyUuid: property ? property.uuid : null,
            accountBalance: selectedAcct.accountBalance,
            firstName: selectedAcct.firstName,
            lastName: selectedAcct.lastName,
            pastDue: pastDue,
            serviceAddress1: unit ? unit.address1 : null,
            serviceAddress2: unit ? unit.address2 : null,
          });
        }
        // if on the account management page loading, the account disconnects have loaded in
        if (!props.account.isLoading && !props.accountDisconnects.isLoading && !accountVerrified) {
          if (props.accountDisconnects.data.accountDisconnectsList.items.some(e => e.completed == 0)) {
            setAccountVerrified(false);
          }
          else {
            setAccountVerrified(true);
          }
        }
      }
    }
  }, [page, property, rowsPerPage, customerType, accountStatusType, accountBalanceOwedFilter, props.isOpen]);

  const CurrentLookupTypeButton = () => {
    return (
      <IconButton onClick={handleSearchTargetButtonClicked} style={{ width: "50px", height: "50px" }}>
        <SearchIcon style={{ width: "30px", height: "30px" }} />
      </IconButton>
    );
  }

  const setSearchFocus = () => {
    setFocus(true);
  }
  const unsetSearchFocus = () => {
    setFocus(false);
  }

  const AccountSearchBar = () => {
    return (
      <>
        {focus ?
          <TextField
            id={"searchTarget"}
            label="Search For Accounts"
            type={"text"}
            onChange={handleSearchTargetChange}
            autoFocus={true}
            name={"searchTarget"}
            defaultValue={searchQuery}
            onBlur={unsetSearchFocus}
            fullWidth
            my={2}
            autoComplete={"off"}
            size={"small"}
            variant={"outlined"}
            InputLabelProps={{
              shrink: true,
            }}
            onKeyPress={(ev) => {
              if (ev.key === 'Enter') {
                // Do code here
                ev.preventDefault();
                setPage(0);
                setResetCachedData(true);
                getAccountsWithQuery();
              }
            }}
            InputProps={{ endAdornment: <CurrentLookupTypeButton /> }}
            helperText="Currently searching by account characteristics. Use Comma to seperate search values"
          >
          </TextField>
          :
          <TextField
            id={"searchTarget"}
            label="Search For Accounts"
            type={"text"}
            onChange={handleSearchTargetChange}
            name={"searchTarget"}
            defaultValue={searchQuery}
            onClick={setSearchFocus}
            fullWidth
            autoComplete={"off"}
            my={2}
            size={"small"}
            variant={"outlined"}
            InputLabelProps={{
              shrink: true,
            }}
            onKeyPress={(ev) => {
              if (ev.key === 'Enter') {
                // Do code here
                ev.preventDefault();
                setPage(0);
                setResetCachedData(true);
                getAccountsWithQuery();
              }
            }}
            InputProps={{ endAdornment: <CurrentLookupTypeButton /> }}
            helperText="Currently searching by account characteristics. Use Comma to seperate search values"
          >
          </TextField>
        }

      </>
    );
  }

  const AccountRowStatusStyling = (account) => {
    account.name = account.lastName;
    if (account.firstName != null) {
      account.name = account.firstName + ", " + account.lastName;
    }

    account.customerType = <StatusTag type={"customerType"} isLoading={props.accountsSearch.isLoading} typeId={account.customerTypeId} showTitle={false} condensed={true} />
    account.accountStatus = <><StatusTag type={"accountStatus"} isLoading={props.accountsSearch.isLoading} typeId={account.accountStatusId} showTitle={false} condensed={true} /></>

    return {}; // Returns an empty style as to not effect each row
  };

  // Table Stuff:      
  const fieldTitles = [
    "Property",
    "Status",
    "Balance",
    "Past Due",
    "Address",
    "Unit",
    "Current Occupant"
  ];

  const fieldTypes = [
    "label",
    ["label", "label"],
    "moneyLabel",
    "moneyLabel",
    "label",
    "label",
    ["label", "label"]
  ];

  const fieldNames = [
    "propertyName",
    ["customerType", "accountStatus"],
    "balance",
    "pastDue",
    "serviceAddress1",
    "serviceAddress2",
  ];
  // Must be the exact name of the properties you wanna show



  const onAccountSelected = (item) => {
    setAccountVerrified(false);
    var selectedAcct = item;
    delete selectedAcct.customerType;
    delete selectedAcct.accountStatus;
    if (selectedAcct.pastDue) {
      setDisconnectAmount(selectedAcct.pastDue);
    }
    else {
      setDisconnectAmount(0);
    }
    setSelectedAccount({
      id: selectedAcct.id,
      uuid: selectedAcct.uuid,
      propertyUuid: selectedAcct.propertyUuid,
      accountBalance: selectedAcct.accountBalance,
      firstName: selectedAcct.firstName,
      lastName: selectedAcct.lastName,
      pastDue: selectedAcct.pastDue,
      serviceAddress1: selectedAcct.serviceAddress1,
      serviceAddress2: selectedAcct.serviceAddress2,
    });
    props.getAccountDisconnects(
      0,
      10,
      "STARTED",
      selectedAcct.accountNum,
      true,
      true,
      ""
    ).then(() => {
      if (props.accountDisconnects.data.accountDisconnectsList.items.length > 0) {
        setAccountVerrified(false);
      }
      else {
        setAccountVerrified(true);
      }
    });
  }

  const handleTargetAccountBalancesChange = (event) => {
    setAccountBalanceOwedFilter(!accountBalanceOwedFilter);
  }
  const handleTypeSelection = (event) => {
    props.accountDisconnects.data.accountDisconnect.type = event.target.value;
    setSelctedDisconnectType(event.target.value);
  }


  const Filters = () => {
    const classes = useStyles();

    return (
      <Grid container spacing={6}>
        <Grid item lg={8} md={8} sm={8}>
          {!props.isAccountPage &&
            <>
              <FormControl fullWidth my={2}>
                <InputLabel id="propertyToBillDropDownLabel">Location{"  "}
                  {props.apl.isLoading &&
                    <CircularProgress size={15} m={0} />
                  }
                </InputLabel>
                {property == "" && props.apl.isLoading ?
                  <Select
                    labelId="propertyToBillDropDownLabel"
                    id="propertyToBillDropDown"
                    value={property}
                    className={classes.selectedPropertyLocationLabel}
                    onChange={handleSelectedPropertyChange}
                    fullWidth
                    disabled
                    my={2}>
                  </Select>
                  :
                  <Select
                    labelId="propertyToBillDropDownLabel"
                    id="propertyToBillDropDown"
                    value={property}
                    className={classes.selectedPropertyLocationLabel}
                    onChange={handleSelectedPropertyChange}
                    fullWidth
                    my={2}>
                    {
                      props.apl.data.propertyPreviews.length > 0 ?
                        [
                          <MenuItem value={""}>All</MenuItem>, ,
                          props.apl.data.propertyPreviews.map((item, key) => {
                            return (
                              <MenuItem value={item.uuid} id={key}>{item.name}</MenuItem>
                            )
                          })
                        ]
                        :
                        [
                          <MenuItem value={-1}>No Properties Found</MenuItem>
                        ]
                    }
                  </Select>
                }
              </FormControl>
            </>
          }
        </Grid>
        <Grid item lg={6} md={6} sm={6}>
          <ButtonGroup
            color="primary"
            aria-label="outlined primary button group"
          >
            <Button
              onClick={() => { onAccountStatusTypeSelected(null) }}
              className={
                accountStatusType == null
                  ? classes.active
                  : classes.inactive
              }
            >
              All
            </Button>
            <Button
              onClick={() => { onAccountStatusTypeSelected("Active") }}
              className={
                accountStatusType == "Active"
                  ? classes.active
                  : classes.inactive
              }
            >
              Active
            </Button>
            <Button
              onClick={() => { onAccountStatusTypeSelected("Inactive") }}
              className={
                accountStatusType == "Inactive"
                  ? classes.active
                  : classes.inactive
              }
            >
              Inactive
            </Button>
          </ButtonGroup>
        </Grid>
        <Grid item lg={6} md={6} sm={6}>
          <ButtonGroup
            color="primary"
            aria-label="outlined primary button group"
          >
            <Button
              onClick={() => { onCustomerTypeSelected(null) }}
              className={
                customerType == null
                  ? classes.active
                  : classes.inactive
              }
            >
              All
            </Button>
            <Button
              onClick={() => { onCustomerTypeSelected("PM") }}
              className={
                customerType == "PM"
                  ? classes.active
                  : classes.inactive
              }
            >
              PM
            </Button>
            <Button
              onClick={() => { onCustomerTypeSelected("Tenant") }}
              className={
                customerType == "Tenant"
                  ? classes.active
                  : classes.inactive
              }
            >
              Tenant
            </Button>
            <Button
              onClick={() => { onCustomerTypeSelected("Common") }}
              className={
                customerType == "Common"
                  ? classes.active
                  : classes.inactive
              }
            >
              Common
            </Button>
          </ButtonGroup>
        </Grid>
        <Grid item lg={4} md={4} sm={4}>
          <FormControlLabel control={<Checkbox
            checked={accountBalanceOwedFilter}
            onClick={handleTargetAccountBalancesChange}
            inputProps={{ "aria-labelledby": "Owed Balance" }}
          />} label="With Owed Balance" />
        </Grid>
      </Grid>
    );
  };
  const save = () => {
    dispatch(setSnackbar(true, "warning", "Creating Account Disconnect"));
    props.accountDisconnects.data.accountDisconnect.account = selectedAccount;
    props.accountDisconnects.data.accountDisconnect.disconnectAmount = disconnectAmount;
    props.post(props.accountDisconnects.data.accountDisconnect, false)
      .then(() => {
        dispatch(setSnackbar(true, "success", "Disconnect created"));
        setSelectedAccount(null);
        props.onUpdate();
      })
      .catch((error) => {
        const message = error?.response?.data?.ERROR || "Error Creating Disconnect!";
        dispatch(setSnackbar(true, "error", message));
        setSelectedAccount(null);
      });
  };

  const onFieldChange = (event) => {
    // Gets the current vendor info data and updates it with the event's name and value:
    if (event.target.type == "number") {
      props.accountDisconnects.data.accountDisconnect[event.target.name] = Number(event.target.value);
    } else {
      props.accountDisconnects.data.accountDisconnect[event.target.name] = event.target.value;
    }
    if (event.target.name == "disconnectAmount") {
      setDisconnectAmount(Number(event.target.value))
    }
  };

  return (
    <Card>
      <CardContent>
        {/* AccountDisconnect Details */}
        <Grid container spacing={2}>
          {!props.isAccountPage &&
            <Grid container item spacing={2}>
              <Grid item lg={12} md={12} sm={12}>
                <AccountSearchBar />
              </Grid>
              <Grid item sm={12} xs={12}>
                <EditableTable
                  Filters={<Filters />}
                  readOnly={false}
                  canAddItems={false}
                  canSave={false}
                  canDelete={false}
                  defaultItemCount={5}
                  isLoading={props.accountsSearch.isLoading}
                  conditionalStylingMethod={AccountRowStatusStyling}
                  // Properties of table  
                  tableTitle={"Select an account to mark for disconnection"}
                  objectArray={props.accountsSearch.data.accountPreviews}
                  currentActiveFilters={[customerType, accountStatusType, propertyName]}
                  fieldTitles={fieldTitles}
                  fieldTypes={fieldTypes}
                  fieldNames={fieldNames}
                  customChangePageRowsEvent={handleChangeRowsPerPage}
                  handleRowClickParentMethod={onAccountSelected}
                  customHandleChangePageEvent={handleChangePage}
                  totalRowCount={props.accountsSearch.data.previewsSummary == null ? 0 : props.accountsSearch.data.previewsSummary.totalRows}
                />
              </Grid>
            </Grid>
          }
          {selectedAccount != null &&
            <Grid container item spacing={2} justify={"flex-end"}>
              <Grid item xs={12}>
                <TableContainer component={Paper}>
                  <Table className={classes.table} aria-label="simple table">
                    <TableBody>
                      <TableRow>
                        <TableCell component="th" scope="row">
                          <Typography variant="h5">Account Holder</Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="h5">
                            {selectedAccount.firstName}  {selectedAccount.lastName}
                          </Typography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell component="th" scope="row">
                          <Typography variant="h5">Selected Address</Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="h5">
                            {selectedAccount.serviceAddress1}{selectedAccount.serviceAddress2 ? `, ${selectedAccount.serviceAddress2}` : ''}
                          </Typography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell component="th" scope="row">
                          <Typography variant="h5">Account Past Due Balance</Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="h5">
                            {formatMoney(selectedAccount.pastDue)}
                          </Typography>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
              <Grid item lg={4} md={6} sm={6}>
                <FormControl fullWidth my={2}>
                  <InputLabel id="disconnectTypeDropDownLabel">New Disconnect Process Status</InputLabel>
                  <Select
                    labelId="disconnectTypeDropDownLabel"
                    id="disconnectTypeDropDown"
                    name="type"
                    className={classes.selectedPropertyLocationLabel}
                    onChange={handleTypeSelection}
                    fullWidth
                    value={selctedDisconnectType}
                    my={2}>
                    {[
                      <MenuItem value={"14"}>14 Day</MenuItem>,
                      <MenuItem value={"10"}>10 Day</MenuItem>,
                      <MenuItem value={"D"}>Disconnect Ready</MenuItem>,
                    ]}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item lg={4} md={6} sm={6}>
                <TextField
                  my={2}
                  fullWidth
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  type="date"
                  id="letterSendDate"
                  label="Letter Send Date"
                  defaultValue={txtBoxDateFormatter(props.accountDisconnects.data.accountDisconnect.letterSendDate)}
                  onChange={onFieldChange}
                  name="letterSendDate"
                />
              </Grid>
              <Grid item lg={4} md={6} sm={6}>
                <TextField
                  my={2}
                  fullWidth
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  type="number"
                  id="disconnectAmount"
                  label="Disconnect Amount (USD)"
                  value={disconnectAmount}
                  onChange={onFieldChange}
                  name="disconnectAmount"
                />
              </Grid>
              {(props.accountDisconnects.isLoading && !accountVerrified) && (
                <Grid item>
                  <Alert severity="warning">
                    Verifying Account...
                  </Alert>
                </Grid>
              )}
              {(!accountVerrified && !props.accountDisconnects.isLoading && selectedAccount) && (
                <Grid item>
                  <Alert severity="error">
                    Account Already Has Existing Unclosed Disconnect
                  </Alert>
                </Grid>
              )}
              <Grid item>
                <MuiButton variant="contained" onClick={props.onCancel} color="primary">
                  Cancel
                </MuiButton>
              </Grid>
              <Grid item>
                {(disconnectAmount > 0 && accountVerrified && !props.accountDisconnects.isLoading) ?
                  <MuiButton variant="contained" onClick={save} color="secondary">
                    Create Disconnect
                  </MuiButton>
                  :
                  <MuiButton variant="contained" disabled onClick={save} color="secondary">
                    Create Disconnect
                  </MuiButton>
                }

              </Grid>
            </Grid>
          }
        </Grid>
      </CardContent>
    </Card>
  );
};

// Component AccountDisconnects
AccountDisconnectForm.propTypes = {
  meters: PropTypes.object.isRequired,
  accountsSearch: PropTypes.object.isRequired,
  account: PropTypes.object.isRequired,
  accountDisconnects: PropTypes.object.isRequired,

  put: PropTypes.func.isRequired,
  post: PropTypes.func.isRequired,
  searchForAccountsByFilters: PropTypes.func.isRequired,
  getAccountDisconnects: PropTypes.func.isRequired,
};

function AccountDisconnectFormState(state) {
  return {
    accountDisconnects: state.accountDisconnects,
    accountsSearch: state.accountsSearch,
    apl: state.apl,
    meters: state.meters,
    account: state.account
  };
}
export default connect(AccountDisconnectFormState, { put, post, searchForAccountsByFilters, getAccountDisconnects })(
  AccountDisconnectForm
);
